import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
	root: {
		margin: '0 auto',
	},
});

const ImageWidget = (props) => {
	const classes = useStyles();

	const { id, value, readonly, disabled, onChange, options, schema, uiSchema } = props;
	return (
		<img
			className={classes.root}
			src={schema.image}
			alt={schema.title}
			width={uiSchema.width}
			height={uiSchema.height}
		/>
	);
};

export default ImageWidget;
